module.exports = __webpack_public_path__ + "img/2023-Calendar-Pop-up.10b10be8.png";